export default function ({ ...props }) {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M8 6.6665L25.3333 23.9998M25.3333 6.6665L8 23.9998" stroke="black" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
